import { ChatSectionHeader } from "./Chat_Header";
import { ChatSectionInput } from "./Chat_Input";
import { ChatSectionMessages } from "./Messages_Section";

export const ChatPage = ({
  chatUser,
  user,
  webinarDetails,
  OnBackfromChat,
}) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <ChatSectionHeader
        chatUser={chatUser}
        webinarId={webinarDetails.id}
        OnBackfromChat={OnBackfromChat}
      />
      <ChatSectionMessages
        recieverUserData={chatUser}
        webinarId={webinarDetails.id}
      />
      <ChatSectionInput
        user={user}
        webinarDetails={webinarDetails}
        chatUser={chatUser}
      />
    </div>
  );
};
